(() => {
  'use strict';

  const MESSAGE_CHANNEL = 'steambow-withdrawal-timestamp';
  const RESYNC_INTERVAL = 5 * 60 * 1000;

  let shopifyClock = null;

  /**
   * Holt die Shopify-Serverzeit aus dem HTTP-Date-Header.
   */
  async function syncShopifyClock() {
    const requestStartedAt = performance.now();
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js?_clock=${encodeURIComponent(Date.now())}`,
      {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `Shopify-Zeitabfrage fehlgeschlagen: HTTP ${response.status}`
      );
    }

    const dateHeader = response.headers.get('date');
    const serverTime = Date.parse(dateHeader || '');
    const responseReceivedAt = performance.now();

    if (!Number.isFinite(serverTime)) {
      throw new Error(
        'Shopify hat keinen verwertbaren Date-Header geliefert.'
      );
    }

    /*
     * Der Date-Header hat Sekundenauflösung.
     * Die halbe Request-Laufzeit wird näherungsweise ergänzt.
     */
    shopifyClock = {
      epochMilliseconds:
        serverTime + (responseReceivedAt - requestStartedAt) / 2,
      performanceReference: responseReceivedAt
    };

    console.log(
      '[Widerruf] Shopify-Serverzeit synchronisiert:',
      new Date(getCurrentShopifyTime()).toISOString()
    );
  }

  /**
   * Führt die Shopify-Zeit anhand der monotonen Laufzeituhr fort.
   */
  function getCurrentShopifyTime() {
    if (!shopifyClock) {
      return null;
    }

    const elapsed =
      performance.now() - shopifyClock.performanceReference;

    return shopifyClock.epochMilliseconds + elapsed;
  }

  /**
   * Sendet die aktuelle Shopify-Zeit an ein bestimmtes Fenster.
   */
  function sendClock(targetWindow, targetOrigin) {
    const epochMilliseconds = getCurrentShopifyTime();

    if (
      !targetWindow ||
      !Number.isFinite(epochMilliseconds)
    ) {
      return;
    }

    targetWindow.postMessage(
      {
        channel: MESSAGE_CHANNEL,
        type: 'SHOPIFY_CLOCK',
        epochMilliseconds
      },
      targetOrigin
    );

    console.log(
      '[Widerruf] Shopify-Zeit an Hulk gesendet:',
      new Date(epochMilliseconds).toISOString()
    );
  }

  /**
   * Hulk meldet sich aus dem iframe, sobald sein Script bereit ist.
   * Wir antworten gezielt an dieses Fenster und dessen Origin.
   */
  window.addEventListener('message', (event) => {
    const data = event.data;

    if (
      !data ||
      data.channel !== MESSAGE_CHANNEL ||
      data.type !== 'HULK_READY'
    ) {
      return;
    }

    console.log(
      '[Widerruf] Hulk-iframe ist bereit:',
      event.origin
    );

    sendClock(event.source, event.origin);
  });

  async function initialize() {
    try {
      await syncShopifyClock();
    } catch (error) {
      console.error(
        '[Widerruf] Shopify-Serverzeit konnte nicht synchronisiert werden:',
        error
      );
    }

    window.setInterval(async () => {
      try {
        await syncShopifyClock();
      } catch (error) {
        console.error(
          '[Widerruf] Erneute Synchronisierung fehlgeschlagen:',
          error
        );
      }
    }, RESYNC_INTERVAL);

    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      try {
        await syncShopifyClock();
      } catch (error) {
        console.error(
          '[Widerruf] Synchronisierung nach Tabwechsel fehlgeschlagen:',
          error
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();